import type { ComponentProps } from 'react';
import type { UiLocale } from '../i18n/ui-strings.js';

type EmojiPickerComponent = (typeof import('emoji-picker-react'))['default'];
type EmojiData = NonNullable<ComponentProps<EmojiPickerComponent>['emojiData']>;

type EmojiDataModule = {
  default: EmojiData;
};

const LOCALE_LOADERS: Record<UiLocale, () => Promise<EmojiDataModule>> = {
  uk: () => import('emoji-picker-react/dist/data/emojis-uk'),
  en: () => import('emoji-picker-react/dist/data/emojis-en'),
  de: () => import('emoji-picker-react/dist/data/emojis-de'),
  fr: () => import('emoji-picker-react/dist/data/emojis-fr'),
};

const cache = new Map<UiLocale, Promise<EmojiData>>();

export function loadEmojiPickerData(locale: UiLocale): Promise<EmojiData> {
  const cached = cache.get(locale);
  if (cached) return cached;

  const promise = LOCALE_LOADERS[locale]().then((module) => module.default);
  cache.set(locale, promise);
  return promise;
}

export type { EmojiData, EmojiPickerComponent };
